/**
 * ClientView — délégation vers ClientWelcome (Sprint V2).
 * ───────────────────────────────────────────────────────
 * Depuis la refonte V2, l'expérience client est unifiée sur
 * /client/welcome (et /client/dossier/:id pour multi-dossiers).
 * Cette route reste conservée pour compatibilité et redirige
 * silencieusement vers l'expérience premium unique.
 */
import { Navigate } from "react-router-dom";

const ClientView = () => <Navigate to="/client/welcome" replace />;

export default ClientView;
